export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.10-1353.35",
  commitId: "c9fab221c6a928a3e9b09130dbc822c5c866d8ea",
  commitTime: "2026-04-10T13:53:35.000Z",
});
